<template>
    <h3 id="header">
      Add personal value to your souvenir magnet!  
    </h3>
    <img id="background" src="../assets/background.png">
    <button id="learnhow" class="mdl-button mdl-js-button mdl-button--raised">
        <router-link :to="{ path: '/about' }" >Learn how!</router-link>
    </button>
</template>

<script>
export default {
  name: 'Home',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

#header {
    margin: 5% 5% 5% 5%;
}
#learnhow {
  bottom: 10%;
}

#background {
  width: 90%;
}
</style>